import Vue from 'vue';
import jsonToFormData from 'json-form-data';
import i18n from './../langs/i18n.js';

export default class FormUtils {
  static loadItemData (instance, config) {
    instance.id = parseInt(instance.$route.params.id, 10);

    if (!config.params) {
      config.params = {};
    }

    if (config.overrideID) {
      instance.id = config.overrideID;
    }

    let endpointUrl = config.endpointBase + instance.id;

    if (config.overrideID === 0) {
      endpointUrl = config.endpointBase;
    }

    instance.$http.post(endpointUrl, config.params).then(response => {
      if (response.data) {
        for (let i = 0; i < config.instanceFields.length; i++) {
          let fieldName = config.instanceFields[i];

          if (config.booleanFields && config.booleanFields.indexOf(fieldName) !== -1) {
            instance[fieldName] = !!response.data.data[fieldName];
          } else {
            instance[fieldName] = response.data.data[fieldName];
          }
        }

        if (config.loadedKey) {
          instance[config.loadedKey] = true;
        }

        if (config.successAction) {
          config.successAction(response.data.data);
        }
      } else {
        // eslint-disable-next-line
        if (config.errorKey) {
          instance[config.errorKey] = true;
        } else {
          instance.loadError = true;
        }
      }
    }).catch(error => {
      console.log(error);

      if (config.errorKey) {
        instance[config.errorKey] = true;
      } else {
        instance.loadError = true;
      }
    });
  }

  static loadAdditionalData (instance, config) {
    instance.$http.post(config.endpoint, config.params).then(response => {
      if (!response.data) {
        instance[config.errorKey] = true;
        return;
      }

      let responseData;

      if (config.noPagination) {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data[config.responseKey];
        } else {
          responseData = response.data;
        }
      } else {
        // eslint-disable-next-line
        if (config.responseKey) {
          responseData = response.data.data[config.responseKey];
        } else {
          responseData = response.data.data;
        }
      }

      if (config.wrapResponseIntoArray) {
        responseData = [responseData];
      }

      // eslint-disable-next-line
      if (config.outputKeyIndex) {
        if (config.outputKey === 'currencies') {
          instance[config.outputKey][config.outputKeyIndex] = responseData.reverse();
        } else {
          instance[config.outputKey][config.outputKeyIndex] = responseData;
        }
      } else {
        // eslint-disable-next-line
        if (config.outputKey === 'currencies') {
          instance[config.outputKey] = responseData.reverse();
        } else {
          instance[config.outputKey] = responseData;
        }
      }

      instance[config.loadedKey] = true;

      if (config.successAction) {
        config.successAction(responseData);
      }
    }).catch(error => {
      console.log(error);
      instance[config.errorKey] = true;

      if (config.catchAction) {
        config.catchAction(error);
      }
    });
  }

  static validate (formRef, successAction, nextCallback = false, failAction = false) {
    formRef.validate().then(result => {
      if (result) {
        if (typeof nextCallback === 'function') {
          successAction(nextCallback);
        } else {
          successAction();
        }
      } else if (typeof failAction === 'function') {
        failAction();
      }
    });
  }

  static submit (config, imageFields = false) {
    if (!imageFields || imageFields.length === 0) {
      config.$http.post(
        config.endpoint,
        config.formData
      ).then(response => {
        if (response.data.success) {
          FormUtils.submitShowSuccess(config, response);
        } else {
          FormUtils.submitShowError(config, response);
        }
      }).catch((error) => {
        FormUtils.submitShowError(config, error.response);
      });
    } else {
      config.$http.request({
        method: 'POST',
        url: config.endpoint,
        headers: { 'Content-Type': undefined },
        transformRequest: (data) => {
          let dataToSend = jsonToFormData(config.formData);

          for (let i = 0; i < imageFields.length; i++) {
            if (typeof imageFields[i] === 'string') {
              dataToSend.append(imageFields[i], data[imageFields[i]]);
            } else if (Array.isArray(imageFields[i])) {
              for (let j = 0; j < imageFields[i].length; j++) {
                dataToSend.append('files[' + j + ']', imageFields[i][j]);
              }
            } else {
              dataToSend.append(imageFields[i].key, imageFields[i].value);
            }
          }

          return dataToSend;
        },
        data: config.formData
      }).then(response => {
        if (response.data.success) {
          if (config.skipSuccessMessage) {
            if (config.successAction) {
              config.successAction(response.data);
            }

            return;
          }
          FormUtils.submitShowSuccess(config, response);
        } else {
          FormUtils.submitShowError(config, response);
        }
      }).catch(error => {
        console.log(error);
        FormUtils.submitShowError(config, error.response);
      });
    }
  }

  static submitShowSuccess (config, response) {
    Vue.swal({
      title: config.successTitle,
      html: config.successText,
      type: 'success',
      timer: 2000,
      confirmButtonText: i18n.t('ui.ok'),
      buttonsStyling: true
    }).then(() => {
      if (config.successAction) {
        config.successAction(response.data);
      }
    }).catch((errors) => {
      console.log(errors);
    });
  }

  static submitShowError (config, response) {
    let errorText = config.errorText;

    if (response && response.data && response.data.errors) {
      let keys = Object.keys(response.data.errors);
      errorText = [];

      for (let i = 0; i < keys.length; i++) {
        errorText.push(response.data.errors[keys[i]]);
      }

      errorText = errorText.join('<br><br>');
    } else if (response && response.data && response.data.error && config.errorMessages) {
      errorText = config.errorMessages[response.data.error];
    }

    Vue.swal({
      title: config.errorTitle,
      html: errorText,
      type: 'warning',
      confirmButtonText: i18n.t('ui.ok'),
      buttonsStyling: true
    }).then(() => {
      if (config.failAction) {
        config.failAction(response);
      }
    });
  }

  static submitInBackground (config, imageFields = false) {
    if (!imageFields || imageFields.length === 0) {
      config.$http.post(
        config.endpoint,
        config.formData
      ).then(response => {
        config.successAction(response.data);
      }).catch(error => {
        console.log(error);
        if (config.failAction) {
          config.failAction(error.response);
        }

        if (!config.skipErrorDisplay) {
          FormUtils.submitShowError(config, error.response);
        }
      });
    } else {
      config.$http.request({
        method: 'POST',
        url: config.endpoint,
        headers: { 'Content-Type': undefined },
        transformRequest: (data) => {
          let dataToSend = jsonToFormData(config.formData);

          for (let i = 0; i < imageFields.length; i++) {
            if (typeof imageFields[i] === 'string') {
              dataToSend.append(imageFields[i], data[imageFields[i]]);
            } else if (Array.isArray(imageFields[i])) {
              for (let j = 0; j < imageFields[i].length; j++) {
                dataToSend.append('files[' + j + ']', imageFields[i][j]);
              }
            } else {
              dataToSend.append(imageFields[i].key, imageFields[i].value);
            }
          }

          return dataToSend;
        },
        data: config.formData
      }).then(response => {
        config.successAction(response.data);
      }).catch(error => {
        console.log(error);
        if (config.failAction) {
          config.failAction(error.response);
        }

        if (!config.skipErrorDisplay) {
          FormUtils.submitShowError(config, error.response);
        }
      });
    }
  }
}
